module.exports = __webpack_public_path__ + "static/media/animated_profile.648042a2.png";